export function deletePayeeByIdV4(send) {
  return (payeeId, ...args) =>
    send(
      {
        path: '/v4/payees/{payeeId}',
        pathParameters: { payeeId },
        type: 'delete',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
